module.exports = __webpack_public_path__ + "static/img/li2_7.2f90876e.png";